<template>
  <div class="welcome-to-panel">
    <div class="welcome-to-panel-component hidden" @click="close">
      <div class="component-background" @click="close" />
      <fade-transition :duration="1000">
        <div v-show="show" class="wrapper" :class="$store.state.theme">
          <button class="delete is-medium is-pulled-right" @click="close" />
          <p class="subtitle is-size-4">{{ welcomeTitle }}</p>
          <div class="is-size-5">
            <p class="has-text-left">{{ welcomeText }}</p>
          </div>
          <br />
          <span class="button is-warning is-rounded" @click="close">
            {{ this.$t("cool") }}!
          </span>
        </div>
      </fade-transition>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";

export default {
  name: "WelcomeToPanel",
  components: {},
  data() {
    return {
      countryCode: "th",
      countryName: "Thailand",
      show: true,
    };
  },
  computed: {
    welcomeTitle() {
      return `Welcome to ${this.countryName}`; // should use countryCode to look for translation first
    },
    welcomeText() {
      var welcomeThailand = `TUK's home country 🙏🏽 where we serve communities in Bangkok and Chiang Mai with more regions coming soon!`;
      if (this.countryCode === "th") return welcomeThailand;
      return `TUK has not launched here yet, but please reach out to us if you would like to bring TUK to your community!`;
    },
  },
  mounted() {
    EventBus.$on("SHOW_WELCOME_TO", (country) => {
      this.countryCode = country.code; // should translate this...
      this.countryName = country.name;
      this.show = true;
      EventBus.$off("SHOW_WELCOME_TO");
    });
  },
  methods: {
    close() {
      this.show = false;
      var name = ".welcome-to-panel-component";
      this.hideComponent(name); // hide automatically...too annoying otherwise
    },
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}
.component-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 2;
}
.wrapper {
  position: absolute;
  bottom: 0px;
  width: 100vw;
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.85);
  padding: 18px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  z-index: 5;
  border-top-right-radius: 25px;
  border-top-left-radius: 25px;
}
.dark {
  background-color: #1c37bd;
  /* background-color: rgba(17, 34, 51, 0.85); */
  color: white;
}
.dark .subtitle {
  color: white;
}

.delete {
  position: absolute;
  right: 0;
  top: 0;
  margin: 10px;
  padding: 10px;
  color: rgba(17, 34, 51, 0.6);
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}
.dark .close {
  color: rgba(255, 255, 255, 0.6);
}
</style>